import React from "react";

function ShowIcon() {
  return (
    <svg
      width="19px"
      height="19px"
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 0h48v48H0z" fill="none" />
      <g id="Shopicon">
        <path
          d="M24,38c12,0,20-14,20-14s-8-14-20-14S4,24,4,24S12,38,24,38z M24,14c7.072,0,12.741,6.584,15.201,9.992
		C36.728,27.396,31.024,34,24,34c-7.072,0-12.741-6.584-15.201-9.992C11.272,20.604,16.976,14,24,14z"
        />
        <path
          d="M24,32c4.418,0,8-3.582,8-8s-3.582-8-8-8s-8,3.582-8,8S19.582,32,24,32z M24,20c2.206,0,4,1.794,4,4c0,2.206-1.794,4-4,4
		s-4-1.794-4-4C20,21.794,21.794,20,24,20z"
        />
      </g>
    </svg>
  );
}

export default ShowIcon;
